import React, {useState} from "react";

import './SlideShow.css'
const SlideShow = ({ images }) => {
    const [slideIndex, setSlideIndex] = useState(0);


    const nextSlides = () => {
        if (slideIndex >= images.length - 1) return;
        setSlideIndex(slideIndex + 1);
    };

    const prevSlides = () => {
        if (slideIndex <= 0) return;
        setSlideIndex(slideIndex - 1);
    }

    return <div className={"slideshow-container"}>
        <a className={slideIndex <= 0 ? "prev hide" : "prev"} onClick={prevSlides}>&#10094;</a>
        {images.map((image, index) =>
            <div
                className={slideIndex === index ? "mySlides fade showSlide" : "mySlides fade hideSlide"}>
                <div className={"slideshow"}>
                    <img src={image}/>
                </div>
                <div className="number-text">{index + 1} / {images.length}</div>
            </div>
        )}
        <a className={images.length - 1 <= slideIndex ? "next hide" : "next"}
           onClick={nextSlides}>&#10095;</a>
    </div>
}

export default SlideShow